import React from "react";
import {
    StandardModal,
    StandardModalActionButton,
    StandardModalActionGroup,
    StandardModalSection,
    StandardModalText
} from "src/components";

function PreSubscriptionActionPrompt(props) {
    const { showDialog, handleClose, confirmCallback, companyDetails, actionName } = props;

    const lowercaseAction = actionName.toLowerCase();

    return (
        <StandardModal
            open={showDialog}
            onClose={handleClose}
            title={`${actionName} Subscription`}
            widthMode="large"
            footer={(
                <StandardModalActionGroup $pushRight>
                    <StandardModalActionButton onClick={handleClose}>
                        Cancel
                    </StandardModalActionButton>
                    <StandardModalActionButton
                        $variant="primary"
                        width="12.5rem"
                        minWidth="12.5rem"
                        onClick={() => confirmCallback()}
                    >
                        {actionName} Subscription
                    </StandardModalActionButton>
                </StandardModalActionGroup>
            )}
        >
            <StandardModalSection>
                <StandardModalText weight="700" size="1.25rem" color="#171A22">
                    {companyDetails.companyName}, would you like to {lowercaseAction} your Me Business subscription?
                </StandardModalText>
                <StandardModalText>
                    Great news! Getting back to all the Me Business features and benefits of your subscription is just a click away. Simply hit the <strong>{actionName} Subscription</strong> button below to enable auto-renew and seamlessly reactivate your subscription directly in your Me Business Account.
                </StandardModalText>
                <StandardModalText>
                    Remember, you are always in control. If you need to, you can cancel your subscription at any time.
                </StandardModalText>
            </StandardModalSection>
        </StandardModal>
    );
}

export default PreSubscriptionActionPrompt;
